import React, { useEffect } from 'react';
import './About.css';

const About = () => {
    useEffect(() => {
        document.title = "À propos - Jeledi";
    }, []);
    return (
        <div className="page about-page">
            <div className="about-hero">
                <div className="container">
                    <h1 className="about-title">L'authenticité par la voix</h1>
                    <p className="about-subtitle">Redéfinir la connexion sociale en supprimant le superficiel.</p>
                </div>
            </div>

            <section className="about-section container">
                <div className="about-grid">
                    <div className="about-card">
                        <h3>Notre Vision</h3>
                        <p>
                            Dans un monde saturé d'images retouchées et de textes impersonnels, nous croyons que la voix est le vecteur d'émotion le plus pur.
                            Jeledi est né d'une volonté simple : remettre l'humain au centre des échanges numériques.
                        </p>
                    </div>
                    <div className="about-card">
                        <h3>Pourquoi la Voix ?</h3>
                        <p>
                            Une voix ne ment pas. Elle porte une intonation, une hésitation, un rire - autant de nuances qu'un texte ne peut capturer.
                            Sur Jeledi, vous n'êtes pas qu'un profil, vous êtes une présence vivante.
                        </p>
                    </div>
                    <div className="about-card">
                        <h3>L'Expérience</h3>
                        <p>
                            Imaginez un fil d'actualité où vous entendez vos amis vous raconter leur journée, comme s'ils étaient à côté de vous.
                            C'est ça, l'expérience Jeledi. Immédiate, chaleureuse, et sans artifice.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
